import axios from 'axios'
import { storage } from '@/plugins/storage'
import { baseUrl } from '@/config/url.config.js'
import { Message } from 'element-ui'
// import store from '@/store'
import { fetchCancel } from './fetchCancel'

import router from '@/router/index.js'

const Service = axios.create({
  timeout: 60000,
  baseURL: baseUrl,
  repeatRequestCancel: true, // 是否开启取消重复请求
  'Access-Control-Allow-Origin': '*',
  headers: {
    'Content-type': 'application/json;charset=utf-8',
  },
})

// 添加请求拦截器
Service.interceptors.request.use(
  (config) => {
    // console.log(config)
    const token = storage.get('TOKEN')
    // 在发送请求之前做些什么
    if (token) {
      // config.headers.Authorization = "Bearer " + userStore.userInfo.token;
      // config.headers.Authorization = "Bearer " + token
    }
    return config
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
Service.interceptors.response.use(
  (response) => {
    fetchCancel.removePending(response.config)
    const data = response.data
    // const userStore = useUserStore()
    const status = Number(response.status) || 200
    if (['blob'].includes(response.config.responseType)) {
      return data
    }
    if (status === 401 && router.currentRoute.value.path != '/login') {
      Message.error(data.msg ? data.msg : '服务器错误')
      this.$store.dispatch('logout')
      return
    }
    if (data.code == 200 || data.code == 1) {
      return data
    } else {
      if (data.code == 401) {
        Message.error(data.msg ? data.msg : '服务器错误')
        this.$store.dispatch('logout')
      } else {
        Message.error(data.msg ? data.msg : '服务器错误')
        return Promise.reject(data)
      }
      console.log(data)
    }
  },
  (error) => {
    // const userStore = useUserStore()
    error.config && fetchCancel.removePending(error.config)
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    if (error.__CANCEL__) return // 重复请求导致的报错不作任何处理
    if (error.response) {
      // 异常有响应
      const { data, status } = error.response

      switch (status) {
        case 403:
          Message.error(data.msg)
          break
        case 502: // 登录信息失效
          Message.error(data.msg)
          break
        case 401:
          //登录失效
          Message.error(data.msg ? data.msg : '登录失效!')
          this.$store.dispatch('logout')
          break
        default:
          Message.error(data.msg)
          break
      }
    } else {
      // 异常无响应
      let { message } = error
      if (message === 'Network Error') message = '连接异常'
      if (message && message.indexof('timeout') != -1) message = '请求超时'
      if (message && message.indexof('Request failed with status code') != -1) {
        const code = message.substr(message.length - 3)
        message = '接口' + code + '异常'
      }
      Message.error(message)
    }
    return Promise.reject(error)
  }
)

// get请求
export const get = async (config) => {
  let ret = await Service({ ...config, method: 'get', params: config.data })
  return ret
}

// post请求
export const post = async (config) => {
  let ret = await Service({ ...config, method: 'post', data: config.data })
  return ret
}

// put请求
export const put = async (config) => {
  let ret = await Service({ ...config, method: 'put', data: config.data })
  return ret
}

// delete请求
export const del = async (config) => {
  let ret = await Service({ ...config, method: 'delete' })
  return ret
}
